import { render, staticRenderFns } from "./ManufactureForm.vue?vue&type=template&id=2f85ec78"
import script from "./ManufactureForm.vue?vue&type=script&lang=js"
export * from "./ManufactureForm.vue?vue&type=script&lang=js"
import style0 from "./ManufactureForm.vue?vue&type=style&index=0&id=2f85ec78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports